import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {OAuthService} from 'angular-oauth2-oidc';
import {ModuleAccessService} from './module-access.service';
import {ROOT_NAVIGATION} from '../../config/navigation.config';

@Injectable({
  providedIn: 'root'
})
export class ModuleGuard  {

  constructor(private oauthService: OAuthService, private router: Router, private moduleAccessService: ModuleAccessService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let redirectUrl = '/no-access';
    const hasIdToken = this.oauthService.hasValidIdToken();
    const hasAccessToken = this.oauthService.hasValidAccessToken();
    const hasAccessToModule = this.moduleAccessService.currentUserHasAccessTo(route.data.moduleType);
    if (hasIdToken && hasAccessToken && hasAccessToModule) {
      return true;
    }

    if (route.routeConfig.path === '') {
      for (const page of ROOT_NAVIGATION) {
        if (this.moduleAccessService.currentUserHasAccessTo(page.module)) {
          redirectUrl = page.path;
          break;
        }
      }
    }

    this.router.navigateByUrl(redirectUrl);
  }
}
